import type { Profile } from "@/core/types";
import type { RootState } from "@/lib/types/state";

/**
 * Selects the user profile from the auth state.
 *
 * @param state - The root Redux state
 * @returns The user profile object or undefined if not available
 */
export const selectProfile = (state: RootState): Profile | undefined => {
  return state?.auth?.profile;
};
